(function () {
  "use strict";

  var swiperInstances = new Map();

  function ensureSwiper(sectionElement, callback) {
    if (window.Swiper) return callback();

    var existingScript = document.querySelector(
      'script[src*="swiper-bundle.min.js"]',
    );

    if (existingScript) {
      existingScript.addEventListener("load", callback, { once: true });
      return;
    }

    var script = document.createElement("script");
    script.src = sectionElement.dataset.swiperSrc;
    script.async = true;
    script.addEventListener("load", callback, { once: true });
    document.head.appendChild(script);
  }

  function initReviewVideos(sectionElement) {
    if (!window.Swiper) {
      ensureSwiper(sectionElement, function () {
        initReviewVideos(sectionElement);
      });
      return;
    }

    var sectionId = sectionElement.dataset.sectionId;
    var swiperElement = sectionElement.querySelector(
      "[data-professional-review-videos-swiper]",
    );
    var swiperKey = sectionId + "-professional-review-videos";

    if (!swiperElement || sectionElement._professionalReviewVideosInitialized) {
      return;
    }
    if (swiperInstances.has(swiperKey)) return swiperInstances.get(swiperKey);

    var reviewSwiper = new Swiper(swiperElement, {
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 16,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      watchSlidesProgress: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      simulateTouch: true,
      allowTouchMove: true,
      touchRatio: 1,
      resistance: true,
      resistanceRatio: 0.85,
      threshold: 5,
      followFinger: true,
      shortSwipes: true,
      longSwipes: true,
      touchEventsTarget: "container",
      centeredSlides: false,
      updateOnWindowResize: true,
      resizeObserver: true,
      speed: 600,
      cssMode: false,
      breakpoints: {
        320: {
          slidesPerView: "auto",
          spaceBetween: 12,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
        768: {
          slidesPerView: "auto",
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });

    swiperInstances.set(swiperKey, reviewSwiper);
    sectionElement._professionalReviewVideosInitialized = true;

    sectionElement
      .querySelectorAll("[data-professional-review-play]")
      .forEach(function (trigger) {
        var media = trigger.closest(".professional-review-video__media");
        var frame = media.querySelector("[data-professional-review-frame]");

        function preloadYoutube() {
          if (!frame || frame.getAttribute("src")) return;
          frame.src = frame.dataset.preloadSrc;
          frame.dataset.preloaded = "true";
          frame.addEventListener(
            "load",
            function () {
              frame.dataset.loaded = "true";
            },
            { once: true },
          );
        }

        function playPreloadedYoutube() {
          frame.contentWindow.postMessage(
            JSON.stringify({ event: "command", func: "playVideo", args: "" }),
            "https://www.youtube.com",
          );
        }

        if (frame) {
          trigger.addEventListener("pointerenter", preloadYoutube, { once: true });
          trigger.addEventListener("focus", preloadYoutube, { once: true });
        }

        trigger.addEventListener("click", function () {
          var playerContainer = media.querySelector(
            "[data-professional-review-player]",
          );
          var video = media.querySelector("[data-professional-review-video]");

          if (!playerContainer) return;

          playerContainer.hidden = false;
          media.classList.add("is-loading");
          if (frame && !frame.getAttribute("src")) {
            frame.src = frame.dataset.src;
          }
          if (frame) {
            if (frame.dataset.preloaded === "true") {
              if (frame.dataset.loaded === "true") {
                playPreloadedYoutube();
                media.classList.remove("is-loading");
                trigger.hidden = true;
              } else {
                frame.addEventListener(
                  "load",
                  function () {
                    playPreloadedYoutube();
                    media.classList.remove("is-loading");
                    trigger.hidden = true;
                  },
                  { once: true },
                );
              }
            } else {
              frame.addEventListener(
                "load",
                function () {
                  media.classList.remove("is-loading");
                  trigger.hidden = true;
                },
                { once: true },
              );
            }
          }
          if (video) {
            video.addEventListener(
              "playing",
              function () {
                media.classList.remove("is-loading");
                trigger.hidden = true;
              },
              { once: true },
            );
            video.play().catch(function () {
              media.classList.remove("is-loading");
            });
          }
        });
      });
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-type="professional-review-videos"]')
      .forEach(initReviewVideos);
  }

  function cleanupSection(sectionElement) {
    var sectionId = sectionElement.dataset.sectionId;
    var swiperKey = sectionId + "-professional-review-videos";

    if (swiperInstances.has(swiperKey)) {
      swiperInstances.get(swiperKey).destroy(true, false);
      swiperInstances.delete(swiperKey);
      sectionElement._professionalReviewVideosInitialized = false;
    }
  }

  function cleanupAll() {
    swiperInstances.forEach(function (swiper) {
      swiper.destroy(true, false);
    });
    swiperInstances.clear();
    document
      .querySelectorAll('[data-section-type="professional-review-videos"]')
      .forEach(function (section) {
        section._professionalReviewVideosInitialized = false;
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(
      '[data-section-type="professional-review-videos"]',
    );
    if (section) initReviewVideos(section);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector(
      '[data-section-type="professional-review-videos"]',
    );
    if (section) cleanupSection(section);
  });

  document.addEventListener("shopify:section:reorder", function () {
    cleanupAll();
    initAll();
  });

  var resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      swiperInstances.forEach(function (swiper) {
        if (swiper && swiper.update) swiper.update();
      });
    }, 250);
  });

  window.addEventListener("beforeunload", cleanupAll);
})();
